import React, {  } from "react";
import { Link } from "react-router-dom";
import { Card, Row, Col, Button } from "react-bootstrap";
import { Section } from "../../shared";

export default function Instructions(props) {
  return (
    <div className="">
      <Section title="Temporary CA ID Number Application" type={"standout"} />
      <div className="container mt-2" style={{ fontSize: "0.9em" }}>
        <Card className="tempid-card">
          <Card.Header>
            <i className="fa fa-align-justify"></i>
            <strong>Information</strong>
            <div className="card-header-actions"></div>
          </Card.Header>
          <Card.Body>
            <Row className="">
              <Col xs="12">
                In the State of California all people or businesses who generate
                hazardous waste must obtain a hazardous waste ID number before
                shipping hazardous waste to a recycler or disposal facility.
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs="12">
                <b className="mr-1">
                  <u>
                    This is the application to obtain a temporary State ID
                    number.
                  </u>
                </b>
                Temporary ID numbers are only good for <b>90 days</b>. You
                cannot obtain an EPA provisional (federal temporary) ID number
                through this online system. For hazardous waste ID numbers other
                than temporary State ID numbers, please go to our Hazardous
                Waste ID Numbers webpage.
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs="12">
                A State ID number may be used if a person generates no more than
                100 kg of RCRA hazardous waste on a monthly basis, and any
                amount of a non-RCRA hazardous waste. One hundred (100) kg is
                220 pounds, which is about 27 gallons of liquid, by volume.
                California-only waste is commonly known as non-RCRA waste.
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs="12">
                Temporary State ID numbers are site-specific and owner-specific.
                Prior to applying for a temporary State ID number, you must
                determine if an active temporary or permanent ID number exists
                for the generator at the address where the hazardous waste is
                being generated. Information on existing ID numbers is available
                at our Hazardous Waste Tracking System (HWTS). Click on the
                report titled “Search for a Company”. If an active number exists
                for the generator at that address, do not apply for another
                number. State temporary ID numbers are issued to a person or
                business that does not routinely generate hazardous waste. Some
                examples of non-routine (not ongoing) activities include:
                <ul>
                  <li>asbestos abatement</li>
                  <li>removing underground tanks </li>
                  <li>
                    removing hazardous waste that was abandoned in a leased
                    building
                  </li>
                </ul>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs="12">
                For more information on ID Numbers, please go to our Hazardous
                Waste ID Numbers webpage.
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs="12">
                If you have any questions, please contact our Telephone
                Information Center at (800) 618-6942. When you hear the voice
                router message, please press 1 and then 6 to speak with our
                staff.
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer>
            <Row className="mt-3">
              <Col xs="6" className="text-center">
                <Link to="/profile">
                  <Button
                    size="lg"
                    style={{
                      width: "200px",
                      backgroundColor: "lightgrey",
                      borderColor: "darkgrey",
                      color: "black",
                    }}
                  >
                    Cancel
                  </Button>
                </Link>
              </Col>
              <Col xs="6" className="text-center">
                <Link to="/tempidverify">
                  <Button
                    variant="success"
                    size="lg"
                    style={{ width: "200px" }}
                  >
                    Proceed
                  </Button>
                </Link>
              </Col>
            </Row>
          </Card.Footer>
        </Card>
      </div>
    </div>
  );
}
